<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12">
          <h1 class="text-white pt-3 px-3">หน้าจัดการสินค้า</h1>
          <p
            class="text-white pb-3 px-3"
          >ผู้ใช้งานสามารถเพิ่ม แก้ไข ลบสินค้าในร้านค้า แต่ในส่วนหน้านี้จะไม่สามารถเพิ่มในส่วนของขนส่งได้</p>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row mb-3 justify-content-between">
        <div class="col-12">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="col-12 col-md-12">
                <h3 class="text-muted">เพิ่มสินค้า</h3>
                <!-- FORM ADD PRODUCT -->
                <form v-on:submit.prevent="addProduct()">
                  <div class="row">
                    <div class="col-md-6 col-12 col-lg-3">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="ชื่อสินค้า"
                          v-model="product.name"
                          :class="{ 'is-invalid': submitAddProduct && $v.product.name.$error }"
                        />
                        <!-- Vuelidate -->
                        <div
                          v-if="submitAddProduct && !$v.product.name.required"
                          class="invalid-feedback"
                        >กรุณากรอกชื่อสินค้า</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.product.name.minLength"
                        >กรุณากรอก"ชื่อสินค้า"อย่างน้อย {{$v.product.name.$params.minLength.min}} ตัวอักษร</div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 col-lg-3">
                      <div class="form-group">
                        <input
                          type="number"
                          step="0.01"
                          min="0.00"
                          class="form-control"
                          placeholder="ต้นทุน"
                          v-model="product.rate"
                          :class="{ 'is-invalid': submitAddProduct && $v.product.rate.$error }"
                        />
                        <!-- Vuelidate -->
                        <div
                          v-if="submitAddProduct && !$v.product.rate.required"
                          class="invalid-feedback"
                        >กรุณากรอกราคาต้นทุน</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.product.rate.decimal"
                        >กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"</div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 col-lg-3">
                      <div class="form-group">
                        <input
                          type="number"
                          step="0.01"
                          min="0.00"
                          class="form-control"
                          placeholder="ราคาขาย"
                          v-model="product.price"
                          :class="{ 'is-invalid': submitAddProduct && $v.product.price.$error }"
                        />
                        <!-- Vuelidate -->
                        <div
                          v-if="submitAddProduct && !$v.product.price.required"
                          class="invalid-feedback"
                        >กรุณากรอกราคาขาย</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.product.price.decimal"
                        >กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"</div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 col-lg-3">
                      <button type="submit" class="btn btn-primary btn-block btn-icon">เพิ่มสินค้า</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 col-md">
                  <h3 class="text-muted">ตารางแสดงข้อมูลสินค้า</h3>
                </div>
                <div class="col-12 col-md-4">
                  <b-form-input v-model="filter" placeholder="ค้นหาสินค้า"></b-form-input>
                </div>
              </div>
            </div>
            <div>
              <div>
                <b-table
                  show-empty
                  responsive
                  :items="itemProduct"
                  :fields="fields"
                  :filter="filter"
                  @filtered="onFiltered"
                  :busy="busy"
                  class="scroll-bar-pop"
                >
                  <div slot="table-busy" class="text-center">
                    <BlockUI >
                      <div class="loader"></div>
                    </BlockUI>
                  </div>
                  <template slot="index" slot-scope="data">{{ data.index+1 }}</template>

                  <template slot="name" slot-scope="row">
                    <input
                      v-if="productUpdate.id == row.item.id"
                      alternative
                      placeholder="ชื่อสินค้า"
                      class="form-control"
                      v-model="productUpdate.name"
                      :class="{ 'is-invalid': submitEditProduct && $v.productUpdate.name.$error }"
                    />
                    <label v-else>{{row.item.name}}</label>
                    <!-- Vuelidate -->
                    <div
                      v-if="submitEditProduct && !$v.productUpdate.name.required"
                      class="invalid-feedback"
                    >กรุณากรอกชื่อสินค้า</div>
                    <div
                      class="error invalid-feedback"
                      v-if="!$v.productUpdate.name.minLength"
                    >กรุณากรอก"ชื่อสินค้า"อย่างน้อย {{$v.productUpdate.name.$params.minLength.min}} ตัวอักษร</div>
                  </template>

                  <template slot="rate" slot-scope="row">
                    <input
                      type="number"
                      step="0.01"
                      min="0.00"
                      v-if="productUpdate.id == row.item.id"
                      alternative
                      placeholder="ราคาขาย"
                      class="form-control"
                      v-model="productUpdate.rate"
                      :class="{ 'is-invalid': submitEditProduct && $v.productUpdate.rate.$error }"
                    />
                    <label v-else>{{row.item.rate | numFormat('0,0.00')}}</label>
                    <!-- Vuelidate -->
                    <div
                      v-if="submitEditProduct && !$v.productUpdate.rate.required"
                      class="invalid-feedback"
                    >กรุณากรอกราคาต้นทุน</div>
                    <div
                      class="error invalid-feedback"
                      v-if="!$v.productUpdate.rate.decimal"
                    >กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"</div>
                  </template>
                <template slot="fee" slot-scope="row">{{ row.item.fee | numFormat('0,0.00') }}</template>

                  <template slot="price" slot-scope="row">
                    <input
                      type="number"
                      step="0.01"
                      min="0.00"
                      v-if="productUpdate.id == row.item.id"
                      alternative
                      placeholder="ต้นทุน"
                      class="form-control"
                      v-model="productUpdate.price"
                      :class="{ 'is-invalid': submitEditProduct && $v.productUpdate.price.$error }"
                    />
                    <label v-else>{{row.item.price | numFormat('0,0.00')}}</label>
                    <!-- Vuelidate -->
                    <div
                      v-if="submitEditProduct && !$v.productUpdate.price.required"
                      class="invalid-feedback"
                    >กรุณากรอกราคาขาย</div>
                    <div
                      class="error invalid-feedback"
                      v-if="!$v.productUpdate.price.decimal"
                    >กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"</div>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <button v-if="productUpdate.id != row.item.id"
                      class="btn btn-sm px-3 btn-info"
                      @click="selectProduct(row.item)"
                    >แก้ไข</button>
                    <button v-else
                        class="btn btn-sm px-3 btn-success"
                        @click="updateProduct(row.item.id)"
                      >อัพเดท</button>
                    <button v-if="productUpdate.id != row.item.id"
                      class="btn btn-sm px-3 btn-danger"
                      @click="confirmDeleteProduct(row.item.id)"
                    >ลบ</button>
                    <button v-else
                      class="btn btn-sm px-3 btn-secondary"
                      @click="cancelUpdateProduct()"
                    >ยกเลิก</button>
                    
                  </template>
                  
                  
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  required,
  minLength,
  numeric,
  decimal
} from "vuelidate/lib/validators";
import validatePop from "../plugins/validatePop.js"
const API_URL = process.env.VUE_APP_API;
export default {
  data() {
    return {
      itemProduct: [],
      submitAddProduct: false,
      submitEditProduct: false,
      busy: true,

      fields: [
        { key: "index", label: "ลำดับ", sortable: true },
        {
          key: "name",
          label: "ชื่อรายการ",
          sortable: true,
          class: "text-center"
        },
        { key: "fee", label: "กำไร", sortable: true },
        { key: "rate", label: "ต้นทุน", sortable: true },
        { key: "price", label: "ราคาขาย", sortable: true },
        { key: "actions", label: "การจัดการ", sortable: true }
      ],
      product: {
        name: "",
        fee: "",
        rate: "",
        price: "",
        total: ""
      },
      productUpdate: {
        id: "",
        name: "",
        fee: "",
        rate: "",
        price: "",
        total: ""
      },
      modal: {
        idDel: "",
        msgBody: "success"
      },
      filter: null,
      currentPage: 1,
      totalRows: 1
    }
  },
  errorSys: {
        apiErrGetProduct: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #001",
        apiErrDelProduct: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #002",
        apiErrAddProduct: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #003",
        apiErrUpdateProduct: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #004",

  },
  validations: {
    product: {
      name: { required, minLength: minLength(2) },
      rate: { required, decimal },
      price: { required, decimal }
    },
    productUpdate: {
      name: { required, minLength: minLength(2) },
      price: { required, decimal },
      rate: { required, decimal }
    }
  },
  mounted() {
    this.getProduct();
  },
  methods: {
    selectProduct(p) {
      this.productUpdate.id = p.id
      this.productUpdate.id = p.id, 
      this.productUpdate.name = p.name, 
      this.productUpdate.price = p.price, 
      this.productUpdate.rate = p.rate
      console.log(p.id, this.productUpdate.id)
    },
    showEditButton(p) {
      return this.productUpdate.id !== p.id ? true : false
    },
    isEdit(p) {
      return this.productUpdate.id === p.id ? true : false
    },
    cancelUpdateProduct(){ 
      this.productUpdate.id = false;
    },
    confirmDeleteProduct(id) {
      this.showComfirmModal()
      this.modal.idDel = id
    },
    getProduct() {
      this.$http
        .get(API_URL + "/shop/products", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              if( checkError.notices == "token is expired"){
                this.$router.push("/logout")
              }
              this.showErrorModal( checkError.msg )
              this.busy = false
              return false
            } 
          this.itemProduct = res.data.data
          this.totalRows = this.itemProduct.length
          this.busy = false
        })
        .catch(error => {
          this.showErrorModal( this.errorSys.apiErrGetProduct )
        });
    },
    addProduct(e) {
      this.submitAddProduct = true;
      this.$v.product.$touch();
      if (this.$v.product.$invalid) {
        return false
      }
      this.product.total = this.product.price - this.product.rate;
      this.$http
        .post(
          API_URL + "/shop/product",
          {
            name: this.product.name,
            rate: this.product.rate,
            fee: this.product.total
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.showErrorModal( checkError.msg )
              return false
            }
          this.showSuccessModal("เพิ่มสินค้าเรียบร้อยค่ะ");
          this.getProduct();
          this.submitAddProduct = false;
          this.product.name = "";
          this.product.rate = "";
          this.product.price = "";
          this.product.total = "";
        })
        .catch(error => {
          this.showErrorModal(this.errorSys.apiErrAddProduct)
        });
    },
    updateProduct(id) {
      this.submitEditProduct = true;
      this.$v.productUpdate.$touch();
      this.busy = true
      if (this.$v.productUpdate.$invalid) {
        return false
      }
      this.productUpdate.total =
        this.productUpdate.price - this.productUpdate.rate;
      this.$http
        .put(
          API_URL + "/shop/product/" + id,
          {
            name: this.productUpdate.name,
            rate: this.productUpdate.rate,
            fee: this.productUpdate.total
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.showErrorModal( checkError.msg )
              return false
            }
          this.showSuccessModal("แก้ไขสินค้าเสร็จสิ้น");
          this.getProduct();
          this.submitEditProduct = false;
          this.productUpdate.id = false;
          this.busy = false;
        })
        .catch(error => {
          this.busy = false;
          this.showErrorModal(this.errorSys.apiErrUpdateProduct)
        })
    },
    deleteProduct() {
      let id = this.modal.idDel;
      this.busy = true
      this.$http
        .delete(API_URL + "/shop/product/" + id, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.showErrorModal( checkError.msg )
              this.busy = false
              return false
            }
          this.busy = false
          this.showSuccessModal("ลบข้อมูลสำเร็จ")
          this.getProduct();
        })
        .catch(error => {
          this.showErrorModal( this.errorSys.apiErrDelProduct )
        })
    },
    showComfirmModal() {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบข้อมูลสมาชิก `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          //for P' OOOO
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.deleteProduct();
          }
        });
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

